import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (selectID) {
  const { isRequestSuccessed, exec, rst } = useRequest({
    url: '',
    name: 'inspectionMethodDelete',
    method: 'DELETE',
  });
  useEffect(() => {
    if (selectID) {
      exec(`/api/inspection/method/${selectID}`)
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectID]);
  return [isRequestSuccessed, rst];
})
